import { render, staticRenderFns } from "./buttons-exams.vue?vue&type=template&id=1b899355&v-if=showExams"
import script from "./buttons-exams.vue?vue&type=script&lang=ts"
export * from "./buttons-exams.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports